/* global ui, appData, grecaptcha */
import emailSpellcheck from './main/emailSpellcheck';
import submitForm from './main/submitForm';
import indexPage from './utils/indexPage';
import { setTitle, changeColorAndIcon, shakeIcon } from './utils/modifyHeaderIcon';
import showLoading from './utils/showLoading';

($ => {
	$(() => {
		indexPage.$firstName = $('#firstName');
		indexPage.$lastName = $('#lastName');
		indexPage.$email = $('#email');
		indexPage.$password = $('#password');
		indexPage.$rType = $('#rType');
		indexPage.$retypePassword = $('#retypePassword');
		indexPage.$agreeToTerms = $('#agreeToTerms');
		indexPage.$subscribeToMarketingEmails = $('#subscribeToMarketingEmails');

		indexPage.$indexFormBtn = $('#indexFormBtn');

		indexPage.$createAccountHeader = $('#createAccountHeader');
		indexPage.$headerIcon = $('#headerIcon');
		indexPage.$headerState = $('#headerState');
		indexPage.$headerTitle = $('#headerTitle');
		indexPage.$headerSubTitle = $('#headerSubTitle');
		indexPage.$firstNameLabel = $('#firstNameLabel');
		indexPage.$lastNameLabel = $('#lastNameLabel');
		indexPage.$emailLabel = $('#emailLabel');
		indexPage.$passwordToggle = $('#passwordToggle');
		indexPage.$retypePasswordDiv = $('#retypePasswordDiv');

		document.getElementById('password').value = '';
		document.getElementById('retypePassword').value = '';

		// TODO - remove this when we add email verification through email notifications
		// ********************* Confirm Email field ********************* //
		// add event listeners for confirm email field only if verifyEmail query param is not false
		if (appData.shouldVerifyEmail) {
			indexPage.$retypeEmail = $('#retypeEmail');
			indexPage.$retypeEmailErrorMessage = $('#retypeEmailErrorMessage');

			// disable pasting into re-type email address field
			indexPage.$retypeEmail.on('paste', event => {
				event.preventDefault();
				indexPage.$retypeEmailErrorMessage.removeClass('noDisplay');
				indexPage.$retypeEmailErrorMessage.attr('aria-hidden', 'false');
				indexPage.$retypeEmail.attr('aria-describedby', 'retypeEmailErrorMessage');
			});
			// accessibility for second email field
			indexPage.$retypeEmail.on('input change', () => {
				indexPage.$retypeEmailErrorMessage.addClass('noDisplay');
				indexPage.$retypeEmailErrorMessage.attr('aria-hidden', 'true');
				indexPage.$retypeEmail.removeAttr('aria-describedby', 'retypeEmailErrorMessage');
			});
			// disable confirm email field if first email field is empty, to prevent user from typing first in the confirm field
			indexPage.$email.on('input', () => {
				if (indexPage.$email[0].value.length === 0) {
					indexPage.$retypeEmail.addClass('disabled');
					indexPage.$retypeEmail.attr('disabled', 'disabled');
				} else {
					indexPage.$retypeEmail.removeClass('disabled');
					indexPage.$retypeEmail.removeAttr('disabled', 'disabled');
				}
			});
		}
		// ****************************** END ****************************** //

		const uiValidatorInstance = ui.validator(document.getElementById('indexForm'), {
			fields: {
				password: { required: true, pattern: 'password' },
				retypePassword: { required: true, match: 'password' },
				agreeToTerms: { required: true },
				email: {
					required: true,
					when: 'blur',
					pattern: field => {
						if (!ui.validator.email(field.value)) {
							return false;
						}
						return true;
					}
				},
				retypeEmail: { required: true, match: 'email' },
				lastName: {
					required: true,
					minLength: 1,
					maxLength: 35,
					when: 'submit',
					pattern: field => {
						if (!/^[a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÄËÏÖÜçÇßøØåÅæÆþÞðÐ\s'.,-]+$/.test(field.value)) {
							return false;
						}
						return true;
					}
				},
				firstName: {
					required: true,
					minLength: 1,
					maxLength: 35,
					when: 'submit',
					pattern: field => {
						if (!/^[a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÄËÏÖÜçÇßøØåÅæÆþÞðÐ\s'.,-]+$/.test(field.value)) {
							return false;
						}
						return true;
					}
				}
			},
			allowMultipleSubmissions: true,
			onSubmit($form) {
				if (!indexPage.allowSubmit) {
					return false;
				}
				showLoading(indexPage.$indexFormBtn);
				changeHeaderState($form);
				verifyCaptcha($form);
			}
		});

		// TODO - remove this when we add email verification through email notifications
		// remove confirm email field from form validator if verifyEmail is false
		if (!appData.shouldVerifyEmail) {
			uiValidatorInstance.removeFields('retypeEmail');
		}

		indexPage.$passwordToggle.click(() => {
			if (indexPage.$passwordToggle.get(0).dataset.passwordismasked === 'true') {
				indexPage.$password.attr('type', 'text');
				indexPage.$passwordToggle.get(0).dataset.passwordismasked = 'false';
				indexPage.$passwordToggle.text(indexPage.$passwordToggle.get(0).dataset.unmasktext);
				indexPage.$retypePasswordDiv.hide();
				uiValidatorInstance.removeFields('retypePassword');
			} else {
				indexPage.$password.attr('type', 'password');
				indexPage.$passwordToggle.get(0).dataset.passwordismasked = 'true';
				indexPage.$passwordToggle.text(indexPage.$passwordToggle.get(0).dataset.masktext);
				indexPage.$retypePasswordDiv.show();
				uiValidatorInstance.addField('retypePassword', { required: true, match: 'password' });
			}
		});

		emailSpellcheck.initialize();
	});
})(jQuery);

function changeHeaderState($form) {
	let firstInvalidFieldId = '';
	const fields = Object.values($form.fields);
	// Checks for error class on each form field
	for (let i = 0; i < fields.length; i++) {
		const field = fields[i];
		if (!field.classList) {
			break;
		}
		for (let j = 0; j < field.classList.length; j++) {
			const className = field.classList[j];
			if (className === 'error') {
				firstInvalidFieldId = field.id;
				break;
			}
		}
		if (firstInvalidFieldId) break;
	}
	// Changes header state to either first invalid field or default state
	if (firstInvalidFieldId) {
		switch (firstInvalidFieldId) {
			case 'firstName': {
				setTitle('invalidFirstName');
				break;
			}
			case 'lastName': {
				setTitle('invalidLastName');
				break;
			}
			case 'email': {
				setTitle('invalidEmail');
				break;
			}
			case 'retypeEmail': {
				setTitle('invalidRetypeEmail');
				break;
			}
			case 'password': {
				setTitle('invalidPassword');
				break;
			}
			case 'retypePassword': {
				setTitle('invalidRetypePassword');
				break;
			}
			case 'agreeToTerms': {
				setTitle('invalidTerms');
				break;
			}
			default:
				break;
		}
		changeColorAndIcon('red', 'person');
		shakeIcon();
	} else {
		setTitle('createAccount');
		changeColorAndIcon('blue', 'person');
	}
}

function verifyCaptcha($form) {
	const action = 'account_create_submit';
	grecaptcha.ready(() => {
		grecaptcha.execute(`${appData.recaptchaSiteKey}`, { action }).then(token => {
			submitForm($form, token);
		});
	});
}
